module.exports = __webpack_public_path__ + "img/verify-request.04dd1b2d.png";